import { gql } from "@apollo/client";

export const PixelTrackingEventTypeDef = gql`
  enum TrackingEventType {
    Custom
    Event
    Goal
  }
`;

export const EntityPrivacyTypeDef = gql`
  enum EntityPrivacy {
    Private
    Public
  }
`;
